<h1 class="visually-hidden" i18n>Video channels</h1>

<div class="margin-content">

  <div class="no-results" i18n *ngIf="channelPagination.totalItems === 0">This account does not have channels.</div>

  <div class="channels" myInfiniteScroller (nearOfBottom)="onNearOfBottom()" [dataObservable]="onChannelDataSubject.asObservable()">
    <div class="channel" *ngFor="let videoChannel of videoChannels">

      <div class="channel-avatar-row">
        <my-actor-avatar
          [actor]="videoChannel" actorType="channel"
          [internalHref]="getVideoChannelLink(videoChannel)"
          i18n-title
          title="See this video channel"
          size="75"
        ></my-actor-avatar>

        <h2 class="fs-5 lh-1 fw-bold m-0">
          <a class="text-decoration-none" [routerLink]="getVideoChannelLink(videoChannel)" i18n-title title="See this video channel">
            {{ videoChannel.displayName }}
          </a>
        </h2>

        <div class="actor-counters">
          <div class="followers" i18n>{videoChannel.followersCount, plural, =0 {No subscribers} =1 {1 subscriber} other {{{ videoChannel.followersCount }} subscribers}}</div>

          <span class="videos-count" *ngIf="getTotalVideosOf(videoChannel) !== undefined" i18n>
            {getTotalVideosOf(videoChannel), plural, =0 {No videos} =1 {1 video} other {{{ getTotalVideosOf(videoChannel) }} videos}}
          </span>
        </div>

        <div class="description-html" [innerHTML]="getChannelDescription(videoChannel)"></div>
      </div>

      <my-subscribe-button [videoChannels]="[videoChannel]"></my-subscribe-button>

      <a i18n class="button-show-channel peertube-button-link primary-button" [routerLink]="getVideoChannelLink(videoChannel)">Show this channel</a>

      <div class="videos-overflow-workaround">
        <div class="videos">
          <div class="no-results h-auto" i18n *ngIf="getTotalVideosOf(videoChannel) === 0">This channel doesn't have any videos.</div>

          <my-video-miniature
            *ngFor="let video of getVideosOf(videoChannel)"
            [video]="video" [user]="userMiniature" [displayVideoActions]="true" [displayOptions]="miniatureDisplayOptions"
          ></my-video-miniature>

          <div *ngIf="getTotalVideosOf(videoChannel)" class="miniature-show-channel">
            <a class="link-primary" i18n [routerLink]="getVideoChannelLink(videoChannel)">SHOW THIS CHANNEL ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
